

export class GetCarouselRequest
{
    roomId?: string;
    departmentId?: string;
    programId?: string;
    projectId?: string;
    roomContentId?: string;
    categoryId?: string;
    search?: string[];
}